module.exports = __webpack_public_path__ + "img/ico-template.14887690.svg";